<template>
  <div class="row">
      <side-menu :title="'個人設定'"></side-menu>
      <div class="col-sm-9 col-md-10 pt-3">
          <toast ref="toast"></toast>

          <ul class="nav nav-tabs">
            <li class="nav-item">
              <a href="#tab1" class="nav-link active" data-toggle="tab" @click="reset">基本設定</a>
            </li>
            <li class="nav-item">
              <a href="#tab2" class="nav-link" data-toggle="tab" @click="reset">写真</a>
            </li>
            <li class="nav-item">
              <a href="#tab3" class="nav-link" data-toggle="tab" @click="reset">勤務登録</a>
            </li>
          </ul>

          <div class="tab-content">
            <!-- 基本タブ -->
            <div id="tab1" class="tab-pane active pt-3">
              <div class="row">
                  <div class="col-12">
                    <form method="post" @submit.prevent="submit">
                        <div class="form-group">
                            <label>メールアドレス</label>
                            <p>{{user.mail}}</p>
                        </div>
                        <div class="form-group">
                            <label>パスワード（変更する場合は入力ください）<span class="text-danger" v-if="invalidPassword">パスワードは6文字以上20文字以下で入力ください</span></label>
                            <input type="password" class="form-control" v-model="user.password" :class="{'border-danger': invalidPassword}" maxlength='20'/>
                        </div>
                        <div class="form-group">
                            <label>緊急連絡先</label>
                            <textarea class="form-control" placeholder="255文字まで自由記入" v-model="user.emergencyContact" maxlength='255' rows="4"></textarea>
                        </div>
                        <button type="submit" class="btn btn-primary">編集</button>
                    </form>
                  </div>
              </div>
            </div>

            <!-- 写真タブ -->
            <div id="tab2" class="tab-pane pt-3">
              <div class="row">
                  <div class="col-12 mt-3">
                      <table class="table">
                        <tr>
                          <td><label>現在の画像</label></td>
                          <td>
                            <img class="card-img-top icon" :src="user.imageUrl ? user.imageUrl : ''" onerror="this.src='/src/assets/img/not_found_user_icon.jpg';">
                            <button v-if="user.imageUrl" class="btn btn-sm btn-outline-danger m-1" style="border-radius:50px;" @click.stop="deleteAttachment">
                                <i class="fa fa-trash"></i>
                                画像を削除
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td><label>新しい画像</label></td>
                          <td>
                            <form  @submit.prevent="upload">
                                <input @change="selectedFile" type="file" name="file" id="uploadFile">
                                <button v-if="uploadFile" type="submit" class="btn btn-info" style="border-radius:50px;">
                                    <i class="fa fa-cloud-upload fa-1x" aria-hidden="true"></i>アップロード
                                </button>
                            </form>
                          </td>
                        </tr>
                      </table>
                  </div>
              </div>
            </div>

            <!-- 勤務登録タブ -->
            <div id="tab3" class="tab-pane pt-3">
              <div class="row">
                  <div class="col-12 mt-3">
                    <div v-if="user.userWorkRegistrationList && user.userWorkRegistrationList.length > 0">
                      <button type="button" v-if="!workRegistEdit" class="btn btn-sm btn-outline-info" data-dismiss="modal" aria-label="Close" @click="setWorkRegistEdit(true)"><i class="fa fa-edit"></i>変更申請する</button>
                      <button type="button" v-else class="btn btn-sm btn-outline-secondary" data-dismiss="modal" aria-label="Close" @click="setWorkRegistEdit(false)"><i class="fa fa-edit"></i>キャンセル</button>
                      <user-work-registration-view v-if="!workRegistEdit" :result="user.userWorkRegistrationList[0]" :loginUser="user"></user-work-registration-view>
                    </div>
                    <user-work-registration-new-edit v-if="!user.userWorkRegistrationList || user.userWorkRegistrationList.length == 0 || workRegistEdit" :propsLoginUser="user"></user-work-registration-new-edit>
                  </div>
              </div>
            </div>
          </div>
      </div>
  </div>
</template>

<style scoped>
.icon {
  border-radius: 50%;
  height: 70px;
  width: 70px;
}
</style>

<script>
import UserWorkRegistrationView from '../common/user/UserWorkRegistrationView.vue'
import UserWorkRegistrationNewEdit from '../common/user/UserWorkRegistrationNewEdit.vue'
import CommonAPI from '../../api/common-api'
import UserAPI from '../../api/user-api'
import SideMenu from './SideMenu.vue'
import Toast from '../Toast.vue'

export default {
  name: 'setting',
  components: {
    SideMenu,
    Toast,
    UserWorkRegistrationView,
    UserWorkRegistrationNewEdit
  },
  data() {
    return {
      showInfo: false,
      invalidPassword: false,
      user: {},
      uploadFile: null,
      workRegistEdit: false,
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
        this.user = val
        this.$root.$refs.loading.$data.show = false
    },
  },
  mounted () {
  },
  methods: {
    // 更新
    submit () {
      // バリデーション
      if (this.user.password != null && (this.user.password.length < 6 || this.user.password.length >= 20)) {
        this.invalidPassword =  true
        return false;
      }

      this.$root.$refs.loading.$data.show = true
      UserAPI.updateSetting(this.user)
          .then(res => {
            this.$root.$refs.loading.$data.show = false
            this.$router.push('/operator/top')
          })
          .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
          })
    },
    // ユーザ情報表示/非表示（スマホ）
    showUserInfo () {
        this.showInfo = !this.showInfo 
    },
    reset() {
      this.user = this.$root.$refs.asnHeader.$data.loginUser
    },
    // ファイル削除
    deleteAttachment() {
        if (window.confirm('削除しますか？')){
            this.$root.$refs.loading.$data.show = true
            UserAPI.deleteFile(this.user.userId)
                .then(res => {
                    this.uploadFile = null
                    document.getElementById('uploadFile').value = ''
                    this.$root.$refs.loading.$data.show = false
                    this.$refs.toast.showToast("ファイルを削除しました", 3000, false)
                    this.getUser()
                })
                .catch(err => {
                    console.error(err)
                    this.$root.$refs.loading.$data.show = false
                })
        }
    },
    // ファイル選択
    selectedFile(e) {
        e.preventDefault();
        let files = e.target.files;
        this.uploadFile = files[0];
        this.isInvalidFile()
    },
    // ファイル検証
    isInvalidFile() {
        // サイズチェック
        if (this.uploadFile.size >= 2000000) {
            this.$refs.toast.showToast("※2MB以上のファイルはアップロードできません。", 3000, true)
            this.uploadFile = null
            document.getElementById('uploadFile').value = ''
            return true
        }
        // ファイルタイプチェック
        let splits =this.uploadFile.name.toLowerCase().split(".");
        let extension = splits[splits.length - 1];
        let allowExtension = ["pdf", "jpg", "jpeg", "png", "xls", "xlsx"];
        if (allowExtension.indexOf(extension) < 0){
            this.$refs.toast.showToast("※PDF/JPG/PNG/Excel以外のファイルはアップロードできません。", 3000, true)
            this.uploadFile = null
            document.getElementById('uploadFile').value = ''
            return true
        }
        return false
    },
    // アップロード
    upload() {
        // バリデーション
        if(this.uploadFile == null || this.isInvalidFile()){
            return
        }
        this.$root.$refs.loading.$data.show = true
        let formData = new FormData();
        formData.append('file', this.uploadFile);
        UserAPI.upload(this.user.userId, formData)
            .then(res => {
                this.uploadFile = null
                document.getElementById('uploadFile').value = ''
                this.$root.$refs.loading.$data.show = false
                this.$refs.toast.showToast("ファイルをアップロードしました。", 3000, false)
                this.getUser()
            })
            .catch(err => {
                console.error(err)
                this.$root.$refs.loading.$data.show = false
            })
    },
    setWorkRegistEdit(val){
      this.workRegistEdit = val
    }
  },
  filters: {
    settingEmpty: function (data) {
      return data ? data : '設定なし'
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/operator/Setting.vue